import { Injectable } from '@angular/core';
import { Http, Response } from "@angular/http";
import { Observable } from "rxjs/Observable";
import 'rxjs/add/operator/map';

import { BrogliaccioDistintaModel } from '../models/brogliacci/brogliaccio-distinta.model';
import { Configurations } from "../core/configurations";
import { BrogliaccioSearchModel } from "../models/brogliacci/brogliaccio-search.model";
import { environment } from "../../environments/environment";
import { DizionarioModel } from "../models/shared/dizionario.model";
import { IncassoModel } from "../models/incassi/incasso.model";
import { LocalDb } from "../core/localdb";
import { newId, guid } from "../core/utilities";
import {AuthService} from "./auth.service";
//OLD
//import { _INCASSI } from "./incassi.service";
//const BROGLIACCI_API: string = 'assets/mock-data/brogliacci';
//const BROGLIACCI_JSONLIST = '/list.json';
//const BROGLIACCI_JSONDETAIL = '/detail.json';

@Injectable()
export class BrogliacciService {
  APIBrogliacci = this.configuration.apiBaseUrlBrogliacci;
  APIStatiBrogliacci = this.configuration.apiBaseUrlStatiBrogliacci;
  apiBaseUrlStampe= this.configuration.apiBaseUrlStampe;
  MethodLista = "listaBrogliacci";
  MethodListaAssociabili = "associabili";
  MethodListaByDistinta = "byDistinta";
  MethodConferma = "conferma";
  MethodPrint = "print";
  //OLD
  //private incassidb: LocalDb<IncassoModel[]> = new LocalDb('INCASSI', _INCASSI);
  //private brogliaccidb: LocalDb<BrogliaccioDistintaModel[]> = new LocalDb('BROGLIACCI', _BROGLIACCI);

  constructor(private http: Http, private configuration: Configurations, private authenticationService:AuthService) { }

  /*
  1- elenco dei brogliacci (ricerca brogliacci)
  2- elenco dei brogliacci associabili a distinte (per quando si crea una nuova distinta)
  3- elenco dei brogliacci appartenenti ad una distinta (ci interessa sapere poi il dettaglio degli incassi)
  4- get specifico brogliaccio
  5- salvataggio nuovo brogliaccio
  6- get lista stati brogliacci
  7- conferma brogliaccio
  8- elimina brogliaccio
  9- update 
  10- stampa
  */


  getFilteredList(model: BrogliaccioSearchModel): Observable<BrogliaccioDistintaModel[]> {
    
    let searchParams = model || new BrogliaccioSearchModel();
    let url = this.APIBrogliacci + this.MethodLista;
    return this.http.post(url, searchParams).map(res => { 
      return res.json() as BrogliaccioDistintaModel[]; })
    .catch((r:any)=> {
        
      if(r.status===401) {
        this.authenticationService.logoutIfSessionExpired().subscribe(
          (res:any)=> {

          });
        return Observable.throw("Autorizzazione negata.");
      }
      Observable.throw(r.json().error || 'Server error');
    });
    
  }

  getBrogliacciAssociabiliList(): Observable<BrogliaccioDistintaModel[]> {

    let url = this.APIBrogliacci + this.MethodListaAssociabili;
    return this.http.get(url)
      .map((r: Response) => r.json() as BrogliaccioDistintaModel[])
      .catch((r:any)=> {
        
        if(r.status===401) {
          this.authenticationService.logoutIfSessionExpired().subscribe(
            (res:any)=> {
  
            });
          return Observable.throw("Autorizzazione negata.");
        }
        Observable.throw(r.json().error || 'Server error');
      });
    

  }

  getBrogliacciDistintaList(gid: string): Observable<BrogliaccioDistintaModel[]> {

    let url = this.APIBrogliacci + this.MethodListaByDistinta;
    return this.http.get(url + '/' + gid)
      .map((r: Response) => r.json() as BrogliaccioDistintaModel[]).catch((r:any)=> {
        
        if(r.status===401) {
          this.authenticationService.logoutIfSessionExpired().subscribe(
            (res:any)=> {
  
            });
          return Observable.throw("Autorizzazione negata.");
        }
        Observable.throw(r.json().error || 'Server error');
      });
    //OLD
    /*if (environment.production) {
      let url = this.API;
      return this.http.get(url)
        .map((r: Response) => r.json() as BrogliaccioDistintaModel[]);
    } else {
      let BROGLIACCI_DATA = this.brogliaccidb.get();
      return Observable.of(BROGLIACCI_DATA
        .filter(item => item.stato.id == 3 && item.idRaggruppamentoPadre == gid))
    }*/

  }

  get(gid: string): Observable<BrogliaccioDistintaModel> {
    return this.http.get(this.APIBrogliacci + gid)
      .map((r: Response) => r.json() as BrogliaccioDistintaModel).catch((r:any)=> {
        
        if(r.status===401) {
          this.authenticationService.logoutIfSessionExpired().subscribe(
            (res:any)=> {
  
            });
          return Observable.throw("Autorizzazione negata.");
        }
        Observable.throw(r.json().error || 'Server error');
      });

    //OLD
    /*
    if (environment.production) {
      let url = this.API;
      return this.http.get(url)
        .map((r: Response) => r.json() as BrogliaccioDistintaModel);
    } else {
      let BROGLIACCI_DATA = this.brogliaccidb.get();
      return Observable.of(BROGLIACCI_DATA.find(item => item.token == gid)
      );
    }*/
  }

  insert(model: BrogliaccioDistintaModel): Observable<Response> {
    let url = this.APIBrogliacci;
    let list= [];
    model.incassi.forEach(element => {
      list.push(element.tokenIncasso);
    });
    return this.http.post(url, list).map((res) => { 
      return res.json(); 
    })
    .catch((r:any)=> {
        
      if(r.status===401) {
        this.authenticationService.logoutIfSessionExpired().subscribe(
          (res:any)=> {

          });
        return Observable.throw("Autorizzazione negata.");
      }
      Observable.throw(r.json().error || 'Server error');
    });

  }

  getStati(): Observable<DizionarioModel[]> {
    let url = this.APIStatiBrogliacci;
    let decod: DizionarioModel[] = [];
    return this.http.get(url)
    .map((r: Response) => r.json() as DizionarioModel[])
    .catch((r:any)=> {
        
      if(r.status===401) {
        this.authenticationService.logoutIfSessionExpired().subscribe(
          (res:any)=> {

          });
        return Observable.throw("Autorizzazione negata.");
      }
      Observable.throw(r.json().error || 'Server error');
    });

  }

  confermaBrogliaccio(model: BrogliaccioDistintaModel): Observable<boolean> {

    let url = this.APIBrogliacci + this.MethodConferma + "/" + model.token;
    return this.http.put(url, null).map(res => { res.json(); return Observable.of(true); })
    .catch((r:any)=> {
        
      if(r.status===401) {
        this.authenticationService.logoutIfSessionExpired().subscribe(
          (res:any)=> {

          });
        return Observable.throw("Autorizzazione negata.");
      }
      Observable.throw(r.json().error || 'Server error');
    });

    //OLD
    /*if (environment.production) {
      let url = this.API;
      //todo
    } else {
      let BROGLIACCI_DATA = this.brogliaccidb.get();
      let editModel = BROGLIACCI_DATA.find(item => item.token == model.token);
      editModel.stato = STATI_BROGLIACCI[1];
      this.brogliaccidb.set(BROGLIACCI_DATA);
      return Observable.of(editModel);
    }*/
  }

  eliminaBrogliaccio(token: string): Observable<boolean> {
    
    let url = this.APIBrogliacci;
     return this.http.delete(url + token).map(res => { res.json(); return Observable.of(true); })
     .catch((r:any)=> {
        
      if(r.status===401) {
        this.authenticationService.logoutIfSessionExpired().subscribe(
          (res:any)=> {

          });
        return Observable.throw("Autorizzazione negata.");
      }
      Observable.throw(r.json().error || 'Server error');
    });
    

    //OLD
    /*if (environment.production) {
      let url = this.API;
      //todo
    } else {
      let BROGLIACCI_DATA = this.brogliaccidb.get();
      this.brogliaccidb.set(BROGLIACCI_DATA.filter(b=> b.token!=model.token));
    }*/
  }

  stampaBrogliaccio(token: string): Observable<Response> {
    
    let url = this.apiBaseUrlStampe;
     return this.http.get(url+ this.MethodPrint+ "/" + token)
     //.map(res => new Blob([res]))
     //.map(res=> res.blob());
     .map(res=> res).catch((r:any)=> {
        
      if(r.status===401) {
        this.authenticationService.logoutIfSessionExpired().subscribe(
          (res:any)=> {

          });
        return Observable.throw("Autorizzazione negata.");
      }
      Observable.throw(r.json().error || 'Server error');
    });
     
  }
  

  update(model: BrogliaccioDistintaModel): Observable<Response> {

    let url = this.APIBrogliacci + model.token;
    return this.http.put(url, null).map(res => { return res.json();  })
    .catch((r:any)=> {
        
      if(r.status=== 401) {
        this.authenticationService.logoutIfSessionExpired().subscribe(
          (res:any)=> {

          });
        return Observable.throw("Autorizzazione negata.");
      }
      Observable.throw(r.json().error || 'Server error');
    });

    
  }
}




// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/services/brogliacci.service.ts